import React from "react";
import "./AboutMe.css";
import aboutMe from "../../Assets/AboutMe.jpg";

const AboutMe = () => {
  return (
    <>
      {" "}
      <div className="aboutMeBannerContainer">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <h1 className="homeBannerTitle">About Me...</h1>
      </div>
      <div className="container">
        <img src={aboutMe} alt="About me" className="homeAboutMeImg" />
        <p className="homeAboutMeText1Desc">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente nisi
          nam nemo facilis placeat explicabo voluptates ad. Cumque cupiditate
          debitis, cum voluptatum quod itaque odit doloremque culpa ad molestias
          accusantium eius repellat. Dignissimos dolor omnis vero iure ipsum
          autem modi est hic voluptatibus praesentium soluta officiis blanditiis
          inventore illum ut quidem assumenda aliquam, natus et impedit totam
          quis earum enim quo! Recusandae enim dignissimos sed iste maxime quia
          temporibus nisi omnis ipsam deleniti veniam, dolore, aut perspiciatis
          tenetur modi odio odit quam itaque esse labore voluptatem! Quae illo
          at esse maxime quasi officiis nobis. Quam numquam a ad possimus
          laborum illum exercitationem. Harum voluptate asperiores dolores illo
          commodi rem eveniet expedita, excepturi distinctio dicta facere
          veritatis fuga laborum quae dolor sunt quos quibusdam, deserunt cum
          fugiat neque sit? Nisi pariatur quos sapiente qui, dignissimos eaque
          nulla voluptate, saepe eos id veritatis dolorum vitae, cum quod
          necessitatibus illum voluptas excepturi aliquid tenetur tempora.
          Adipisci nemo doloremque quas ea iure accusantium? Blanditiis ipsum,
          numquam dignissimos sint, incidunt labore at laborum voluptatem magni
          accusamus magnam molestias amet. Sequi, nemo ab. Nihil hic ipsam
          maxime nam commodi. Ab officiis adipisci dignissimos iure, similique
          excepturi. Ex iusto quidem in delectus harum obcaecati reiciendis
          doloribus provident, quisquam sit totam repellendus fugiat ea eveniet
          odio aspernatur, quia quos culpa quas. Beatae, facere pariatur nulla
          quaerat quos asperiores atque eum cumque commodi nesciunt aspernatur.
          Voluptate, enim voluptatibus! Omnis ex totam fugit consequatur
          recusandae ratione nulla vitae quasi ea est, autem, vero culpa
          laboriosam possimus earum qui repudiandae facilis minus repellat?
          Assumenda saepe incidunt cumque, asperiores porro provident ex illo
          ipsum quo architecto dolores impedit? Exercitationem dicta repellat,
          minima dolor impedit voluptatum optio eos saepe sunt libero, pariatur
          laboriosam cumque ullam sit minus. Corporis illum pariatur laudantium
          numquam voluptas quia, veniam molestias aspernatur blanditiis,
          consequuntur minus iure accusamus commodi. Eligendi quod perferendis
          nam, odit numquam aut ducimus tempora praesentium repellat placeat
          cumque excepturi pariatur iste, error fugit dolorum. Quod eos totam
          accusamus, doloribus officia nisi veniam omnis explicabo incidunt,
          quia magni at voluptate? Labore, minus. Perspiciatis iusto non
          similique tempora qui optio possimus consequuntur, vel odio
          necessitatibus dicta officia, animi, debitis corrupti voluptates
          aperiam voluptatibus quaerat error temporibus vero ullam magnam!
          Maiores voluptatum nostrum atque, iste quasi reiciendis aut debitis
          odio, facere, vel dolorem provident veritatis. Aperiam, veniam? Dicta
          nisi perspiciatis alias, quas aliquam, nesciunt quae asperiores vitae
          commodi a eveniet nam quidem molestias quam enim corrupti unde?
          Nostrum expedita voluptates optio, error provident perspiciatis,
          voluptate enim dolorum, iure velit magni magnam adipisci a explicabo
          nam quod eos id atque reprehenderit eius obcaecati blanditiis hic?
          Labore hic iure dolores exercitationem quos nam maiores saepe error ad
          aperiam nemo sed, quia aspernatur consectetur deleniti, culpa dicta
          suscipit non sapiente quidem magni provident? Laborum et quo itaque
          commodi eveniet atque quas at, neque ullam suscipit consectetur minus
          a omnis iste rerum explicabo animi numquam ut inventore beatae nemo
          quod fugit accusantium consequatur. Amet porro velit inventore
          reiciendis, numquam vero! Earum reprehenderit necessitatibus nulla
          voluptates totam. At, voluptatem. Omnis debitis numquam asperiores.
        </p>
      </div>
      <div className="text-center">
        <h2 className="">CONNECT WITH ME</h2>

        <a
          href="http://"
          target="_blank"
          rel="noopener noreferrer"
          style={{color: "#000000"}}>
          Facebook
        </a>
        <br />
        <br />
        <a
          href="http://"
          target="_blank"
          rel="noopener noreferrer"
          style={{color: "#000000"}}>
          Instagram
        </a>
        <br />
        <br />
        <a
          href="http://"
          target="_blank"
          rel="noopener noreferrer"
          style={{color: "#000000"}}>
          Twitter
        </a>
        <br />
        <br />
        <a
          href="http://"
          target="_blank"
          rel="noopener noreferrer"
          style={{color: "#000000"}}>
          Pinterest
        </a>
      </div>
    </>
  );
};

export default AboutMe;
